// Original React component rewritten in Danish based on the Swedish source.

import React from 'react';

const A2 = () => {

    return <>
        <h2>
            Tilgængelighed for LäraNäras portal
        </h2>

        <p>LäraNära AB står bag dette websted. Vi ønsker, at så mange som muligt kan bruge det. Dette dokument beskriver, hvordan LäraNäras portal lever op til loven om visse produkters og tjenesters tilgængelighed, eventuelle kendte tilgængelighedsproblemer, og hvordan du kan rapportere mangler til os, så vi kan afhjælpe dem.</p>

        <h3>Hvor tilgængeligt er webstedet?</h3>

        <p>Vi er opmærksomme på, at dele af webstedet ikke er fuldt tilgængelige. Se afsnittet om indhold, der ikke er tilgængeligt, nedenfor for mere information.</p>

        <h3>Hvad kan du gøre, hvis du ikke kan bruge dele af webstedet?</h3>

        <p>Hvis du har brug for indhold fra LäraNäras portal, som ikke er tilgængeligt for dig, men som er undtaget fra lovens anvendelsesområde som beskrevet nedenfor, kan du kontakte os via:</p>

        <ul>
            <li>Feedbackformularen på webstedet</li>
            <li>Email: info@laranara.se</li>
            <li>Telefon: +46 708 48 95 94 på hverdage mellem 8–16</li>
        </ul>

        <p>Vi bestræber os på at svare inden for én arbejdsdag.</p>

        <h3>Rapportér tilgængelighedsproblemer på webstedet</h3>

        <p>Vi arbejder løbende på at forbedre webstedets tilgængelighed. Hvis du opdager problemer, der ikke er beskrevet på denne side, eller hvis du mener, at vi ikke overholder lovens krav, bedes du give os besked.</p>

        <h3>Tilsyn</h3>

        <p>Myndigheden for digital forvaltning i Sverige (Digg) har ansvaret for tilsyn med loven om visse produkters og tjenesters tilgængelighed. Du kan <a href="https://www.digg.se/tdosanmalan">indberette til Digg</a>, hvis du mener, at vores digitale service har mangler i tilgængelighed.</p>

        <p>Du kan også <a href="https://www.digg.se/tdosanmalan">indberette til Digg</a>, hvis du mener, at vores vurdering af, hvad der udgør en uforholdsmæssig stor byrde, bør gennemgås, hvis vores tilgængelighedserklæring har mangler, eller hvis du mener, at vi ikke har håndteret din anmodning korrekt.</p>

        <h3>Teknisk information om webstedets tilgængelighed</h3>

        <p>Dette websted er delvist i overensstemmelse med tilgængelighedsloven på grund af de mangler, der er beskrevet nedenfor.</p>

        <h2>Indhold som ikke er tilgængeligt</h2>

        <h3>For dig med nedsat syn eller farveblindhed</h3>
        <ul>
            <li>Mange ikoner mangler beskrivende alt-tekster eller aria-labels.</li>
            <li>Flere billeder og ikoner mangler alt-tekster.</li>
            <li>Skærmlæsere får ikke adgang til statusmeddelelser.</li>
            <li>Overskriftsstrukturer mangler eller er forkerte.</li>
            <li>Formularfelter mangler etiketter eller er forkert forbundet.</li>
            <li>Tabeller mangler overskrifter og semantisk markering.</li>
            <li>Farvekontraster er ofte utilstrækkelige.</li>
            <li>Fokusmarkering er uklar eller mangler.</li>
            <li>Tastaturnavigation fungerer ikke fuldt ud.</li>
            <li>Nogle videoer mangler undertekster, lydbeskrivelser eller alternative tekster.</li>
            <li>"Spring til indhold" mangler.</li>
            <li>Dokumenttitler er ikke unikke.</li>
            <li>Fokusrækkefølge er ikke logisk.</li>
        </ul>

        <h3>For dig med kognitive udfordringer</h3>
        <ul>
            <li>Indholdet mangler tydelige overskrifter og logisk struktur.</li>
            <li>Ikoner og links er ikke altid selvforklarende.</li>
            <li>Links, der åbnes i nye faner, informerer ikke brugeren om dette.</li>
            <li>Ingen synlig eller tilgængelig hjælpfunktion findes.</li>
        </ul>

        <h3>For dig med nedsat finmotorik eller styrke</h3>
        <ul>
            <li>De fleste interaktive mål er tilstrækkeligt store.</li>
            <li>Nogle funktioner kræver musebevægelser uden alternativ metode.</li>
        </ul>

        <h3>For dig med nedsat hørelse eller uden hørelse</h3>
        <ul>
            <li>Forudindspillede videoer mangler nogle gange undertekster.</li>
            <li>Der er ingen lydbeskrivelser af videoer med vigtigt visuelt indhold.</li>
        </ul>

        <h2>Planlagte tiltag</h2>

        <p>Vi arbejder løbende med at forbedre tilgængeligheden på LäraNära-portalen. Følgende tiltag er prioriterede og planlægges gennemført:</p>

        <h3>For brugere med nedsat syn eller farveblindhed</h3>
        <ul>
            <li>Tilføje beskrivende alt-tekster og aria-labels til ikoner og billeder.</li>
            <li>Sikre korrekt overskriftsstruktur på alle sider.</li>
            <li>Korrigere formularfelter og etiketter.</li>
            <li>Tilføje semantisk markering til tabeller.</li>
            <li>Forbedre farvekontraster.</li>
            <li>Gøre fokusmarkering tydeligere.</li>
            <li>Gøre alle interaktive elementer tilgængelige via tastatur.</li>
            <li>Sikre, at statusmeddelelser er tilgængelige.</li>
        </ul>

        <h3>For brugere med kognitive udfordringer</h3>
        <ul>
            <li>Forbedre overskrifter og etiketter.</li>
            <li>Gøre dokumenttitler mere præcise.</li>
            <li>Informere om links, der åbnes i nye faner.</li>
            <li>Tilføje links til hjælp og kontakt.</li>
        </ul>

        <h3>For brugere med nedsat finmotorik eller styrke</h3>
        <ul>
            <li>Tilbyde alternative metoder til musebevægelser.</li>
        </ul>

        <h3>For brugere med nedsat hørelse eller uden hørelse</h3>
        <ul>
            <li>Transskribere og tekste alle videoer.</li>
            <li>Tilbyde lydbeskrivelser eller tekstalternativer til visuelt indhold.</li>
        </ul>

        <p>Vores mål er at løse alle kendte tilgængelighedsproblemer senest december 2025.</p>

        <h2>Sådan har vi testet webstedet</h2>

        <p>Toxic Interactive Solutions AB har foretaget en uafhængig vurdering af LäraNära-portalen.</p>

        <p>Du kan finde deres rapport her: <a rel="noopener noreferrer" target='_blank' href="https://static.laranara.se/policies/Tillganglighetsanalys-LaraNara.pdf">Rapport</a></p>

        <p>Seneste vurdering blev udført den 13. maj 2025 i henhold til WCAG 2.2 op til niveau AA.</p>
    </>
}

export default A2;
